/* Shrine owns normal variant updates; a server-confirmed fallback handles stalled updates. Teeinblue owns personalization. */
(() => {
  const CONFIG = {"15440042328363":{"number":1,"artwork":1372346},"15443728531755":{"number":2,"artwork":1372340},"15443728564523":{"number":3,"artwork":1372347},"15443728597291":{"number":4,"artwork":1372353,"optionIndex":0,"choices":{"template-440001":"2 Names","template-440002":"3 Names","template-440003":"4 Names","template-440004":"5 Names","template-440005":"6 Names","template-440006":"7 Names","template-440007":"8 Names","template-440008":"9 Names","template-440009":"10 Names"}},"15443728630059":{"number":5,"artwork":1372354,"optionIndex":0,"choices":{"template-450001":"2 Names","template-450002":"3 Names","template-450003":"4 Names","template-450004":"5 Names","template-450005":"6 Names","template-450006":"7 Names","template-450007":"8 Names","template-450008":"9 Names","template-450009":"10 Names"}},"15443728662827":{"number":6,"artwork":1372355,"optionIndex":0,"choices":{"template-460001":"2 Names","template-460002":"3 Names","template-460003":"4 Names","template-460004":"5 Names","template-460005":"6 Names"}},"15443728695595":{"number":7,"artwork":1372356,"optionIndex":0,"choices":{"template-470001":"1 KID","template-470002":"2 KIDS","template-470003":"3 KIDS","template-470004":"4 KIDS","template-470005":"5 KIDS","template-470006":"6 KIDS"}},"15443728728363":{"number":8,"artwork":1372357,"optionIndex":0,"choices":{"template-480001":"3 Rabbits","template-480002":"4 Rabbits","template-480003":"5 Rabbits"}},"15443728793899":{"number":9,"artwork":1372358,"optionIndex":0,"choices":{"template-490001":"2 Bears","template-490002":"3 Bears","template-490003":"4 Bears","template-490004":"5 Bears","template-490005":"6 Bears","template-490006":"7 Bears","template-490007":"8 Bears","template-490008":"9 Bears"}},"15443728826667":{"number":10,"artwork":1372359,"optionIndex":0,"choices":{"template-500001":"2 Bears","template-500002":"3 Bears","template-500003":"4 Bears","template-500004":"5 Bears","template-500005":"6 Bears","template-500006":"7 Bears","template-500007":"8 Bears","template-500008":"9 Bears"}},"15443728892203":{"number":11,"artwork":1372360,"optionIndex":0,"choices":{"template-510001":"2 Wolves","template-510002":"3 Wolves","template-510003":"4 Wolves","template-510004":"5 Wolves","template-510005":"6 Wolves"}},"15443728924971":{"number":12,"artwork":1372343,"optionIndex":0,"choices":{"template-921201":"Cuple With Dog #1","template-921202":"Cuple With Dog #2"}},"15443728957739":{"number":13,"artwork":1372344,"optionIndex":0,"choices":{"template-921301":"Man With Puppy","template-921302":"Man With Dog","template-921303":"Woman With Puppy","template-921304":"Woman With Dog","template-921305":"Man Sit With Dog","template-921306":"Woman Sit With Dog","template-921307":"Woman With Cat","template-921308":"Man With Cat","template-921309":"Couple Sit With Puppy"}},"15443728990507":{"number":15,"artwork":1372352,"optionIndex":1,"colorLayer":"layer-921501","choices":{"32043854":"Blue","32043855":"Champaign","32043856":"Pink","32043857":"Purple","32043858":"Red","32043859":"Yellow"},"aliases":{"DarkBlue":"Blue","Dark Blue":"Blue","Champagne":"Champaign"}}};

  function initialize() {
    const dataNode = document.getElementById('np-sculpture-data');
    if (!dataNode || dataNode.dataset.npAdapterBound) return;
    let data;
    try { data = JSON.parse(dataNode.textContent || 'null'); } catch { return; }
    const config = CONFIG[String(data?.productId)];
    if (!config || !Array.isArray(data.variants)) return;
    dataNode.dataset.npAdapterBound = 'true';

    const container = document.getElementById('MainContent') || document.querySelector('main');
    if (!container) return;
    const normalize = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    const normalizeOption = value => normalize(config.aliases?.[value] || value);
    const section = () => container.querySelector('[id^="MainProduct-"]') || container;
    const mainForm = () => section().querySelector('product-form.main-product-form form[action*="/cart/add"]')
      || section().querySelector('form[id^="product-form-"][action*="/cart/add"]');
    const nativePicker = () => section().querySelector('variant-selects, variant-radios');
    const teeForm = () => section().querySelector('#tee-artwork-form');
    const nativeId = () => String(mainForm()?.querySelector('input[name="id"]')?.value || '');
    const sharedPurchase = document.body.classList.contains('npu');
    const productView = new URL(location.href).searchParams.get('view');
    const byId = id => data.variants.find(variant => String(variant.id) === String(id));
    const choiceForVariant = variant => Object.keys(config.choices || {}).find(choice =>
      normalizeOption(config.choices[choice]) === normalizeOption(variant?.options?.[config.optionIndex]));
    const choiceField = () => teeForm()?.querySelector(config.colorLayer
      ? `[id="tee-field--${config.colorLayer}"]`
      : `[id="tee-field--${config.artwork}-template"]`);
    const textInputs = () => [...(teeForm()?.querySelectorAll('input[type="text"], textarea') || [])];
    const inputSignature = () => textInputs().map(input => input.id).join('|');
    const optionGroups = () => [...(nativePicker()?.querySelectorAll('.product-form__input') || [])]
      .filter(group => group.querySelector('select, input[type="radio"]'));
    const selectedOptions = () => optionGroups().map(group =>
      group.querySelector('select')?.value ?? group.querySelector('input[type="radio"]:checked')?.value);
    const variantFromOptions = () => {
      const options = selectedOptions();
      if (!options.length || options.some(value => value == null)) return null;
      return data.variants.find(variant => variant.options?.length === options.length
        && variant.options.every((value, index) => normalizeOption(value) === normalizeOption(options[index])));
    };

    const names = new Map();
    const templateSignatures = new Map();
    const abort = new AbortController();
    let desiredVariant = byId(data.selectedVariantId) || byId(nativeId()) || data.variants[0];
    let currentBranch = null;
    let pendingBranchClear = null;
    let pendingTemplate = null;
    const pendingChoices = new Map(config.number === 15
      ? [['layer-921502', 'title'], ['layer-921503', 'quote']] : []);
    let restoring = false;
    let frame = 0;
    let timer = 0;
    let settleUntil = Date.now() + 15000;
    let fallbackSequence = 0;
    let fallbackTimer = 0;
    let fallbackController = null;
    let fallbackAvailability = null;

    document.body.classList.add('np-sculpture-product', 'np-bakven-sculpture');
    document.body.dataset.npSculptureAdapter = 'shrine';
    document.body.dataset.npSculptureSelection = 'loading';
    document.body.dataset.npNativeFallback = 'idle';

    const branchFor = variant => config.number === 13
      ? (choiceForVariant(variant) === 'template-921309' ? 'couple' : 'single') : 'shared';
    const keyFor = input => {
      const heading = input.closest('.tee-field')?.querySelector('.tee-field__heading')?.cloneNode(true);
      heading?.querySelectorAll('.np-bakven-counter, .tee-asterisk').forEach(node => node.remove());
      const label = normalize(heading?.textContent.replace(/\*/g, ''));
      if (!label) return '';
      if (config.number !== 13) return label;
      const aliases = {
        'enter name': 'person-1', "enter man's name": 'person-1',
        "enter woman's name": currentBranch === 'single' ? 'person-1' : 'person-2',
        "enter pet's name": 'pet', "enter dog's name": 'pet'
      };
      return `${currentBranch}:${aliases[label] || label}`;
    };
    const setInput = (input, value) => {
      if (input.value === value) return;
      input.value = value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const clearInputs = () => {
      restoring = true;
      for (const input of textInputs()) setInput(input, '');
      restoring = false;
    };
    const rememberInputs = () => {
      if (restoring || pendingBranchClear) return;
      for (const input of textInputs()) {
        const key = keyFor(input);
        if (key) names.set(key, input.value);
      }
    };
    const updateIntent = variant => {
      if (!variant) return;
      const nextBranch = branchFor(variant);
      if (currentBranch !== null && nextBranch !== currentBranch) {
        // The source replaces its option set across the single/couple boundary.
        names.clear();
        clearInputs();
        pendingBranchClear = { branch: nextBranch, choice: choiceForVariant(variant), previousSignature: inputSignature() };
      } else if (String(desiredVariant?.id) !== String(variant.id)) {
        rememberInputs();
      }
      currentBranch = nextBranch;
      desiredVariant = variant;
      settleUntil = Date.now() + 15000;
    };

    const selectedTeeChoice = () => {
      const field = choiceField();
      const select = field?.querySelector('select');
      if (select) return select.value;
      const input = field?.querySelector('.tee-radio.active input, .tee-clipart.active input, input[type="radio"]:checked');
      return config.colorLayer ? input?.id.split('-').at(-1) : input?.value;
    };
    const applyTeeChoice = choice => {
      const field = choiceField();
      if (!field || !choice) return false;
      if (selectedTeeChoice() === choice) return true;
      const previousSignature = inputSignature();
      if (!pendingTemplate && selectedTeeChoice() && previousSignature) {
        templateSignatures.set(selectedTeeChoice(), previousSignature);
      }
      const select = field.querySelector('select');
      if (select instanceof HTMLSelectElement) {
        if (![...select.options].some(option => option.value === choice)) return false;
        pendingTemplate = { choice, previousSignature };
        select.value = choice;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const input = [...field.querySelectorAll('input')].find(item => config.colorLayer
          ? item.id.endsWith(`-${choice}`) : item.value === choice);
        const label = input?.closest('.tee-radio, .tee-clipart')?.querySelector('label');
        if (!label) return false;
        if (!config.colorLayer) pendingTemplate = { choice, previousSignature };
        label.click();
      }
      settleUntil = Date.now() + 15000;
      return true;
    };

    const gateSelect = (select, placeholderText, marker) => {
      if (!(select instanceof HTMLSelectElement)) return;
      let placeholder = [...select.options].find(option => option.value === '')
        || [...select.options].find(option => option.disabled && /choose an option/i.test(option.textContent));
      if (!placeholder) {
        placeholder = document.createElement('option');
        placeholder.value = '';
        select.prepend(placeholder);
      }
      if (!placeholder.disabled) placeholder.disabled = true;
      if (placeholder.textContent !== placeholderText) placeholder.textContent = placeholderText;
      // The source starts unselected. Do not ask the SDK to switch to a fake template.
      if (select.value !== placeholder.value) select.value = placeholder.value;
      select.required = true;
      select.dataset[marker] = 'true';
    };
    const hasPendingChoice = () => pendingChoices.size > 0;
    const applySelectionGates = () => {
      for (const id of pendingChoices.keys()) {
        gateSelect(teeForm()?.querySelector(`[id="${id}"]`), 'Choose an option', 'npChoiceGate');
      }
    };

    const teeSelectionMatches = () => {
      if (!teeForm()?.querySelector('.tee-field') || !desiredVariant) return false;
      if (!config.choices) return true;
      return selectedTeeChoice() === choiceForVariant(desiredVariant) && !pendingTemplate && !pendingBranchClear;
    };
    const ready = () => !hasPendingChoice() && teeSelectionMatches()
      && nativeId() === String(desiredVariant.id);
    const syncFallbackButton = () => {
      if (!fallbackAvailability || fallbackAvailability.id !== String(desiredVariant?.id)
        || nativeId() !== fallbackAvailability.id) return;
      const button = mainForm()?.querySelector('button[type="submit"][name="add"]');
      if (!button) return;
      const requiredInputsFilled = textInputs().every(input => input.getBoundingClientRect().height === 0
        || (!(input.required || input.getAttribute('aria-required') === 'true') || input.value.length > 0)
          && input.checkValidity());
      const nativeFieldsValid = Number(button.dataset.requiredFields || 0) <= Number(button.dataset.validFields || 0);
      const disabled = !fallbackAvailability.available || !ready() || !requiredInputsFilled || !nativeFieldsValid;
      if (button.disabled !== disabled) button.disabled = disabled;
      if (fallbackAvailability.available) button.removeAttribute('data-unavailable');
      else button.dataset.unavailable = 'true';
      const label = button.querySelector('.main-atc__label');
      if (label && fallbackAvailability.labelHTML && label.innerHTML !== fallbackAvailability.labelHTML) {
        label.innerHTML = fallbackAvailability.labelHTML;
      }
    };
    const armNativeFallback = () => {
      const sequence = ++fallbackSequence;
      clearTimeout(fallbackTimer);
      fallbackController?.abort();
      fallbackController = null;
      fallbackAvailability = null;
      const id = String(desiredVariant?.id || '');
      const picker = nativePicker();
      const form = mainForm();
      if (!id || !picker?.dataset.section || !picker.dataset.url || !form?.getAttribute('id')) return;
      const sectionId = picker.dataset.section;
      const formId = form.getAttribute('id');
      const productUrl = new URL(picker.dataset.url, location.origin);
      const stillCurrent = () => sequence === fallbackSequence && !abort.signal.aborted
        && String(desiredVariant?.id) === id && String(variantFromOptions()?.id) === id;
      const state = value => {
        if (sequence === fallbackSequence) document.body.dataset.npNativeFallback = value;
      };
      const run = async () => {
        if (!stillCurrent()) return;
        if (!sharedPurchase && nativeId() === id) { state('native'); return; }
        if (!teeSelectionMatches()) {
          if (Date.now() < settleUntil) fallbackTimer = setTimeout(run, 200);
          else state('tee-pending');
          return;
        }
        const controller = new AbortController();
        fallbackController = controller;
        const url = new URL(productUrl);
        url.searchParams.set('variant', id);
        url.searchParams.set('section_id', sectionId);
        // Section rendering must use the same alternate template as the visible form.
        // A matching variant ID alone does not confirm that its price/button were refreshed.
        if (productView) url.searchParams.set('view', productView);
        if (!['main', 'live'].includes(document.body.dataset.npThemeRole)
          && document.body.dataset.npThemeId) {
          url.searchParams.set('preview_theme_id', document.body.dataset.npThemeId);
        }
        state('fetching');
        const requestTimeout = setTimeout(() => {
          if (stillCurrent()) state('timeout');
          controller.abort();
        }, 8000);
        try {
          const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal,
            headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          if (!stillCurrent()) return;
          if (!sharedPurchase && nativeId() === id) { state('native'); return; }
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const serverSection = parsed.getElementById(`MainProduct-${sectionId}`);
          const serverForm = parsed.getElementById(formId);
          const serverPicker = serverSection?.querySelector('variant-selects, variant-radios');
          const serverId = serverForm?.querySelector('input[name="id"]')?.value;
          const serverVariants = JSON.parse(serverPicker?.querySelector('script[type="application/json"]')?.textContent || 'null');
          const serverProduct = JSON.parse(serverSection?.querySelector('script[type="application/ld+json"]')?.textContent || 'null');
          const serverVariant = Array.isArray(serverVariants) && serverVariants.find(item => String(item.id) === id);
          const correctProduct = Array.isArray(serverVariants) && serverVariants.length === data.variants.length
            && new Set(serverVariants.map(item => String(item.id))).size === data.variants.length
            && serverVariants.every(item => byId(item.id)) && serverProduct?.['@type'] === 'Product'
            && new URL(serverProduct.url, location.origin).pathname === productUrl.pathname
            && new URL(serverPicker.dataset.url, location.origin).pathname === productUrl.pathname;
          const price = section().querySelector('[id^="main-price-"]')
            || document.getElementById(`price-${sectionId}`);
          const serverPrice = price?.id && parsed.getElementById(price.id);
          const button = mainForm()?.querySelector('button[type="submit"][name="add"]');
          const serverButton = serverForm?.querySelector('button[type="submit"][name="add"]');
          if (!correctProduct || !serverVariant || !serverSection?.contains(serverForm) || serverId !== id
            || !serverPrice || !serverSection.contains(serverPrice) || !price || !button || !serverButton) {
            state('rejected'); return;
          }
          if (!stillCurrent()) return;
          if (!sharedPurchase && nativeId() === id) { state('native'); return; }
          if (!teeSelectionMatches()) { state('tee-pending'); return; }
          // Only server-confirmed variant data is copied; keep the live form and Tee listeners intact.
          price.className = serverPrice.className;
          price.innerHTML = serverPrice.innerHTML;
          const input = mainForm().querySelector('input[name="id"]');
          input.value = serverId;
          input.setAttribute('value', serverId);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          fallbackAvailability = { id, available: serverVariant.available === true && !serverButton.disabled,
            labelHTML: serverButton.querySelector('.main-atc__label')?.innerHTML };
          const currentUrl = new URL(location.href);
          currentUrl.searchParams.set('variant', id);
          history.replaceState(history.state, '', currentUrl);
          state('applied');
          syncFallbackButton();
          schedule();
        } catch (error) {
          if (error.name !== 'AbortError' && stillCurrent()) state('error');
        } finally {
          clearTimeout(requestTimeout);
          if (fallbackController === controller) fallbackController = null;
        }
      };
      state('waiting');
      document.body.dataset.npNativeFallbackVariant = id;
      fallbackTimer = setTimeout(run, 1500);
    };
    const showPending = () => {
      let status = mainForm()?.querySelector('.np-sculpture-status');
      if (!status && mainForm()) {
        status = document.createElement('p');
        status.className = 'np-sculpture-status';
        status.setAttribute('role', 'status');
        mainForm().prepend(status);
      }
      const pendingChoice = pendingChoices.entries().next().value;
      const message = pendingChoice ? `Please choose a ${pendingChoice[1]}.`
        : 'Updating your selection. Please try again in a moment.';
      if (status) status.textContent = message;
      if (hasPendingChoice()) {
        const select = teeForm()?.querySelector(`[id="${pendingChoice[0]}"]`);
        select?.setCustomValidity(message);
        select?.reportValidity();
      }
      schedule();
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(() => { frame = 0; refresh(); });
    };
    const refresh = () => {
      clearTimeout(timer);
      if (!teeForm()?.querySelector('.tee-field')) return;
      const variant = variantFromOptions() || byId(nativeId()) || desiredVariant;
      if (String(variant?.id) !== String(desiredVariant?.id) || currentBranch === null) updateIntent(variant);
      const choice = choiceForVariant(desiredVariant);
      applySelectionGates();
      if (config.choices && choice && applyTeeChoice(choice)) {
        const field = choiceField();
        // CSS may hide this only after the real native option is available.
        if (field && nativePicker()) field.dataset.npNativeChoice = 'true';
        if (field && config.colorLayer) field.dataset.npVariantLinked = 'true';
      }
      if (pendingTemplate && selectedTeeChoice() === pendingTemplate.choice
        && (inputSignature() !== pendingTemplate.previousSignature
          || templateSignatures.get(pendingTemplate.choice) === inputSignature())) pendingTemplate = null;
      if (pendingBranchClear && currentBranch === pendingBranchClear.branch
        && !pendingTemplate && selectedTeeChoice() === pendingBranchClear.choice
        && (inputSignature() !== pendingBranchClear.previousSignature
          || templateSignatures.get(pendingBranchClear.choice) === inputSignature())
        && textInputs().length === (currentBranch === 'couple' ? 3 : 2)) {
        clearInputs();
        names.clear();
        pendingBranchClear = null;
      }
      if (!pendingTemplate && selectedTeeChoice() && inputSignature()) {
        templateSignatures.set(selectedTeeChoice(), inputSignature());
      }
      if (!pendingTemplate && !pendingBranchClear) {
        restoring = true;
        for (const input of textInputs()) {
          const saved = names.get(keyFor(input));
          if (!input.value && saved) setInput(input, saved.slice(0, input.maxLength > 0 ? input.maxLength : undefined));
        }
        restoring = false;
      }
      const settled = ready();
      document.body.dataset.npSculptureSelection = settled ? 'ready' : 'updating';
      document.body.dataset.npSculptureVariant = String(desiredVariant?.id || '');
      document.body.classList.toggle('np-sculpture-ready', settled);
      syncFallbackButton();
      if (settled) mainForm()?.querySelector('.np-sculpture-status')?.remove();
      if (!settled && !hasPendingChoice() && Date.now() < settleUntil) timer = setTimeout(schedule, 80);
    };

    container.addEventListener('input', event => {
      const input = event.target;
      if (restoring || pendingBranchClear || !(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)
        || !input.closest('#tee-artwork-form')) return;
      const key = keyFor(input);
      if (key) names.set(key, input.value);
      if (fallbackAvailability) schedule();
    }, { signal: abort.signal });
    container.addEventListener('change', event => {
      if (restoring || !(event.target instanceof Element)) return;
      const picker = nativePicker();
      if (picker?.contains(event.target)) {
        updateIntent(variantFromOptions());
        armNativeFallback();
      }
      if (pendingChoices.has(event.target.id) && event.target instanceof HTMLSelectElement
        && [...event.target.options].some(option => option.value === event.target.value && !option.disabled)) {
        pendingChoices.delete(event.target.id);
        event.target.setCustomValidity('');
        mainForm()?.querySelector('.np-sculpture-status')?.remove();
        settleUntil = Date.now() + 15000;
      }
      schedule();
    }, { signal: abort.signal });
    container.addEventListener('submit', event => {
      if (event.target === mainForm() && !ready()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showPending();
      }
    }, { capture: true, signal: abort.signal });
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const mainButton = event.target.closest('button[type="submit"][name="add"]');
      const previewButton = event.target.closest('#preview-teeAtcButton');
      const gatedReview = hasPendingChoice() && event.target.closest('#tee-artwork-form button.tee-btn--preview');
      if ((mainButton?.form === mainForm() || previewButton || gatedReview) && !ready()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showPending();
      }
      // Do not redirect a valid Teeinblue preview cart action without storefront validation.
    }, { capture: true, signal: abort.signal });

    const observer = new MutationObserver(schedule);
    observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'value', 'checked', 'id'] });
    window.addEventListener('pagehide', () => {
      abort.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
      clearTimeout(timer);
      clearTimeout(fallbackTimer);
      fallbackController?.abort();
    }, { once: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
